import { SearchRoot } from "./Search.Root";
import { SearchIconComponent } from "./Search.Icon";
import { SearchInput } from "./Search.Input";
import { SearchClose } from "./Search.Close";
import { Search as SearchComponent } from "./Search";

// Export all types
export type {
  SearchRootProps,
  SearchIconProps,
  SearchInputProps,
  SearchCloseProps,
  SearchProps
} from "./Search.types";

// Create Search with subcomponents attached
const Search = Object.assign(SearchComponent, {
  Root: SearchRoot,
  Icon: SearchIconComponent,
  Input: SearchInput,
  Close: SearchClose
});

export { Search };
